import { render } from "./ChapterStory.vue?vue&type=template&id=32eb2a0b"
import script from "./ChapterStory.vue?vue&type=script&lang=js"
export * from "./ChapterStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__